"use client";
import React from "react";
import Badge from "./Badge";
import AnalyticsUsageChart from "./AnalyticsUsageChart";

const TotalUsageSection: React.FC = () => {
  return (
    <section className="w-full">
      <div className="px-4 w-full">
        <div className="w-full">
          <header className="w-full text-lg font-semibold leading-loose text-gray-900">
            <div className="flex gap-4 w-full">
              <h2 className="flex-1 shrink w-full basis-0 min-w-60">
                Total Usage
              </h2>
            </div>
          </header>
          <div className="flex gap-4 items-end mt-4 w-full text-sm font-medium leading-none">
            <p className="text-3xl font-semibold leading-none text-gray-900">
              247L
            </p>
            <div className="pb-2 text-center text-emerald-700 whitespace-nowrap">
              <Badge variant="success-icon" icon="https://cdn.builder.io/api/v1/image/assets/e8fd2a11e5e6412dbddb276a310a5dca/af073f4a61c83535a7896111dbbef16a1b01b1b6?placeholderIfAbsent=true">
                7.2%
              </Badge>
            </div>
            <div className="pb-2 text-center text-blue-700">
              <Badge variant="info-icon" icon="https://cdn.builder.io/api/v1/image/assets/e8fd2a11e5e6412dbddb276a310a5dca/450dc3e3b1c01f39fe2347b444555b730e7352e7?placeholderIfAbsent=true">
                Goal achieved
              </Badge>
            </div>
          </div>
        </div>
        <AnalyticsUsageChart />
      </div>
    </section>
  );
};

export default TotalUsageSection;
